"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/readySection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ReadySectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "PHYSIOTHERAPY" */
    h30Text?: ReactNode;
    /** Detected variants: "title" */
    h30ClassName?: string;
};

type ReadySectionServicesSlides2Item = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-eighteen-1.svg" | "/Templates/Doccure/img/company/company-eighteen-2.svg" | "/Templates/Doccure/img/company/company-eighteen-3.svg" | "/Templates/Doccure/img/company/company-eighteen-4.svg" | "/Templates/Doccure/img/company/company-eighteen-5.svg" | "/Templates/Doccure/img/company/company-eighteen-6.svg" */
    src: string;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "company-item-sixteen" */
    div0ClassName?: string;
    /** Detected variants: "img" */
    alt?: string;
};
export type HomeEighteenReadySectionGeneratedProps = {
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReadySectionServicesSlides2Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ReadySectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "#" */
    sectionDiv0A0AHref?: string;
    /** Default: "All Services" */
    sectionDiv0A0AText?: ReactNode;
    /** Default: "left" */
    sectionDiv0Div0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0Div0DivDataSpeed?: string;
    /** Default: "Ready to Start Your" */
    sectionDiv0H20H2Text?: ReactNode;
    sectionDiv0H20H2Visible?: boolean;
    sectionDiv0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Recovery Journey?" */
    sectionDiv0H20Span0SpanText?: ReactNode;
    /** Default: "ready" */
    sectionDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/ready-shadow-1.png" */
    sectionDiv0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "right" */
    sectionDiv1DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv1DivDataSpeed?: string;
    readySectionServicesSlides: ReadySectionServicesSlidesItem[];
    readySectionServicesSlides2: ReadySectionServicesSlides2Item[];
    readySectionServicesSlidesItemWrapper?: (item: ReadySectionServicesSlidesItem, content: ReactNode) => ReactNode;
    readySectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    readySectionServicesSlidesH3Visible?: boolean;
    readySectionServicesSlidesH3Renderer?: (item: ReadySectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    readySectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: ReadySectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    readySectionServicesSlides2ItemWrapper?: (item: ReadySectionServicesSlides2Item, content: ReactNode) => ReactNode;
    readySectionServicesSlides2Renderer?: (defaultNode: ReactNode) => ReactNode;
    readySectionServicesSlides2ImageVisible?: boolean;
    readySectionServicesSlides2ImageRenderer?: (item: ReadySectionServicesSlides2Item, defaultNode: ReactNode) => ReactNode;
    readySectionServicesSlides2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReadySectionServicesSlides2Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeEighteenReadySectionGenerated: FC<HomeEighteenReadySectionGeneratedProps> = ({
    sectionDiv0A0AHref = "#",
    sectionDiv0A0AText = "All Services",
    sectionDiv0Div0DivDataDirection = "left",
    sectionDiv0Div0DivDataSpeed = "slow",
    sectionDiv0H20H2Text = "Ready to Start Your",
    sectionDiv0H20H2Visible,
    sectionDiv0H20H2Renderer,
    sectionDiv0H20H2Props,
    sectionDiv0H20Span0SpanText = "Recovery Journey?",
    sectionDiv0ImageWithBasePath0ImageAlt = "ready",
    sectionDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/ready-shadow-1.png",
    sectionDiv0ImageWithBasePath0ImageVisible,
    sectionDiv0ImageWithBasePath0ImageRenderer,
    sectionDiv0ImageWithBasePath0ImageProps,
    sectionDiv1DivDataDirection = "right",
    sectionDiv1DivDataSpeed = "slow",
    divDiv0ImageWithBasePath0ImageProps,
    divH30H3Props,
    readySectionServicesSlides,
    readySectionServicesSlides2,
    readySectionServicesSlidesItemWrapper,
    readySectionServicesSlidesRenderer,
    readySectionServicesSlidesH3Visible,
    readySectionServicesSlidesH3Renderer,
    readySectionServicesSlidesH3Props,
    readySectionServicesSlides2ItemWrapper,
    readySectionServicesSlides2Renderer,
    readySectionServicesSlides2ImageVisible,
    readySectionServicesSlides2ImageRenderer,
    readySectionServicesSlides2ImageProps,
}) => {
    return (
        <section className="section ready-section-eighteen">
            <div className="ready-content" style={{ position: "relative", overflow: "hidden" }}>
                {renderNode(sectionDiv0H20H2Visible, sectionDiv0H20H2Renderer, (
                    <h2 className="title" {...(sectionDiv0H20H2Props ?? {})}>
                        {sectionDiv0H20H2Text}
                        <span>{sectionDiv0H20Span0SpanText}</span>
                    </h2>
                ))}
                <div className="horizontal-slide slide-eighteen one d-flex" data-direction={sectionDiv0Div0DivDataDirection} data-speed={sectionDiv0Div0DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            readySectionServicesSlides,
                            (item: ReadySectionServicesSlidesItem) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(readySectionServicesSlidesH3Visible, readySectionServicesSlidesH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "title"} {...(typeof readySectionServicesSlidesH3Props === "function" ? readySectionServicesSlidesH3Props(item) : (readySectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text ?? "PHYSIOTHERAPY"}</h3>
                                    ))}
                                </div>
                            ),
                            readySectionServicesSlidesItemWrapper,
                            readySectionServicesSlidesRenderer
                        )}
                    </div>
                </div>
                {renderNode(sectionDiv0ImageWithBasePath0ImageVisible, sectionDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionDiv0ImageWithBasePath0ImageSrc} alt={sectionDiv0ImageWithBasePath0ImageAlt} className="ready-shadow-1" {...(sectionDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
                <a href={sectionDiv0A0AHref} className="ready-link">
                    <span className="icon">
                        <i className="isax isax-arrow-right-14"></i>
                    </span>
                    {sectionDiv0A0AText}
                </a>
            </div>
            <div className="horizontal-slide two d-flex" data-direction={sectionDiv1DivDataDirection} data-speed={sectionDiv1DivDataSpeed}>
                <div className="slide-list d-flex">
                    {renderCollectionNode(
                        readySectionServicesSlides2,
                        (item: ReadySectionServicesSlides2Item) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                <div className={item.div0ClassName ?? "company-item-sixteen"}>
                                    {renderItemNode(readySectionServicesSlides2ImageVisible, readySectionServicesSlides2ImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof readySectionServicesSlides2ImageProps === "function" ? readySectionServicesSlides2ImageProps(item) : (readySectionServicesSlides2ImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        readySectionServicesSlides2ItemWrapper,
                        readySectionServicesSlides2Renderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeEighteenReadySectionGenerated;
